import { render } from "./CommodityItem.vue?vue&type=template&id=9bf82c76&scoped=true"
import script from "./CommodityItem.vue?vue&type=script&lang=js"
export * from "./CommodityItem.vue?vue&type=script&lang=js"

import "./CommodityItem.vue?vue&type=style&index=0&id=9bf82c76&scoped=true&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_ad\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf82c76"]])

export default __exports__